import { Component, Inject } from '@angular/core';
import { DOCUMENT } from '@angular/common';
import { environment } from '../environments/environment';
import { Title } from '@angular/platform-browser';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppComponent {
  env = environment;

  constructor(
    @Inject(DOCUMENT) public document: Document,
    private titleService: Title
  ) {
    const window: any = this.document.defaultView;
    const host = window.location.hostname;
    this.setDynamicStyle(host);
  }

  // public favIcon: any = this.document.querySelector('#favicon');

  async setDynamicStyle(host: any) {
    // console.log(typeof host, host, this.env, this.env.hosts, this.env.host);
    // console.log(host);
    // console.log(this.env);

    const allthemes = ['blue-body','orange-body','dark-body','yellow-body','green-body','darkcyan-body'];
    

    const index = this.env.hosts.findIndex((e: any) => host === e.domain);
    this.env.host = (index == -1) ? this.env.hosts[0] : this.env.hosts[index];
    if (index == -1) {
      this.env.host.domain = host;
    }
    if (!localStorage.getItem(`${this.env.panel}theme`)) {
      
      //set default style written in env host wise
      //localStorage.setItem(`${this.env.panel}theme`, this.env.host.theme);
      
      //set default style with random selection
      const random = Math.floor(Math.random() * allthemes.length);
      //console.log(random, allthemes[random]);
      const randomTheme = allthemes[random];
      localStorage.setItem(`${this.env.panel}theme`, randomTheme);

    }
    this.titleService.setTitle(`Welcome to ${this.env.host.name == 'localhost' ? host : this.env.host.name}`);

    if (this.env.host.name != 'localhost') {
      this.env.baseUrl = `https://api.${this.env.host.domain}`;
      this.env.domain = this.env.host.domain;
    }

    // this.env.guestEnable = this.env.host.guestEnable;

    // console.log(this.env.host);

    // this.favIcon.href = `assets/img/${this.env.host.name}/favicon.ico`;
  }
}
